import React, { Component } from 'react';
import { intlShape } from 'react-intl';
import PropTypes from 'prop-types';
import querystring from 'query-string';

import Shell from '@shared/containers/Shell';
import { ROUTES } from '@services/routes.service';
import {
  CHAT_BASE_URL,
  HOST_IS_READY_MESSAGE,
  HELPCENTER_STARTED_MESSAGE,
  HELPCENTER_ASKS_FOR_SHUTDOWN,
} from './constants';
import messages from './messages';
import ChatContainer from './components/Container';
import ChatWindow from './components/Window';
import connect from './connect';

const MS_WAITING_CHAT_IFRAME = 3000;

class Chat extends Component {
  state = {
    isClient: false,
    isLoading: false,
  };

  componentDidMount() {
    const { goBack, trackOnlineHelpClicked } = this.props;

    window.addEventListener('message', event => {
      const messageType = event.data.type;
      const port = event.ports[0];
      if (port) {
        if (messageType === HELPCENTER_STARTED_MESSAGE) {
          port.postMessage({
            type: HOST_IS_READY_MESSAGE,
            payload: {
              isHelpcenterFullScreen: true,
              supportedMessageTypes: [HELPCENTER_ASKS_FOR_SHUTDOWN],
            },
          });
        }
        port.onmessage = shutDownEvent => {
          const { data: message } = shutDownEvent;
          if (message) {
            if (message.type === HELPCENTER_ASKS_FOR_SHUTDOWN) {
              goBack(ROUTES.HOME);
            }
          }
        };
      }
    });

    trackOnlineHelpClicked();
    this.setState({ isLoading: true, isClient: true }, () => {
      setTimeout(() => {
        this.setState({ isLoading: false });
      }, MS_WAITING_CHAT_IFRAME);
    });
  }

  chatUrl = () => {
    const { orderId, location } = this.props;
    const searchParams = new URLSearchParams(location?.search);
    const query = {
      orderId,
    };

    if (searchParams.has('orderId')) {
      query.orderId = searchParams.get('orderId');
    }

    if (searchParams.has('page_id')) {
      query.page_id = searchParams.get('page_id');
    }

    const queryParams = querystring.stringify(query, {
      skipNull: true,
      skipEmptyString: true,
    });

    return queryParams ? `${CHAT_BASE_URL}?${queryParams}` : CHAT_BASE_URL;
  };

  render() {
    const {
      intl: { formatMessage },
    } = this.props;
    const { isClient, isLoading } = this.state;

    return (
      <Shell showOverlaySpinner={isLoading}>
        {isClient && (
          <ChatContainer>
            <ChatWindow
              title={formatMessage(messages.chatWindowTitle)}
              frameBorder="0"
              src={this.chatUrl()}
            />
          </ChatContainer>
        )}
      </Shell>
    );
  }
}

Chat.propTypes = {
  intl: intlShape,
  trackOnlineHelpClicked: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
  orderId: PropTypes.string,
  location: PropTypes.object,
};

export default connect(Chat);
